import { Form, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import { SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import TarikhPicker from '../TarikhPicker';
import ShareHolderReports from './ShareHolderReports';
import PrepareAuxFile from './AuxFile';

class MoneyInOut extends Component {
    state = {
        row: this.props.row ?? {},
        shareHolders: [],
    }

    componentDidMount() {
        ShareHolderReports.fetchShareHoldersLookupP(true)
            .then(shareHolders => this.setState({ shareHolders }))
            .catch(window.notif);
        // apiPostP('/api/dyna/rowsAsLookup/shareHolder', {})
        //     .then(res => {
        //         let { list, error } = res ?? { error: 'No response' };
        //         if (error?.length > 0) {
        //             window.notif(error);
        //             return;
        //         }
        //         window.shareHoldersLookup = list;
        //         this.setState({ shareHolders: list });
        //     }).catch(window.notif)
    }

    render() {
        return (
            <div>
                <Form colCount={60} rtlEnabled labelLocation='left' editFormProps={{ labelLocation: window.mView ? 'top' : 'left' }}
                >
                    {/* 
                    <SimpleItem colSpan={30} label='نوع تراکنش'>
                    <SelectBox items={[{ id: 0, summary: 'واریز' }, { id: 1, summary: 'برداشت' }]}
                        valueExpr='id' displayExpr='summary'
                        value={this.state.row.direction}
                        onValueChanged={e => this.setState({ row: { ...this.state.row, direction: e.value } })}
                    />
                    </SimpleItem> 
                */}
                    <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'سهامدار' }}
                    >
                        <SelectBox items={this.state.shareHolders} valueExpr='id' displayExpr='summary' rtlEnabled
                            value={this.state.row.fk_shareholder} readOnly={this.props.readOnlyShareHolder}
                            //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                            onValueChanged={e => { this.state.row.fk_shareholder = e.value; this.forceUpdate(); }}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'مبلغ' }}>
                        <NumberBox min={1} //format={{ type: 'thousands' }}
                            value={this.state.row.val}
                            onValueChanged={e => { this.state.row.val = e.value; this.forceUpdate(); }}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'تاریخ' }}>
                        <TarikhPicker
                            value={this.state.row.tarikh}
                            onValueChanged={e => { this.state.row.tarikh = e;/*.text;*/ this.forceUpdate(); }}
                        />
                    </SimpleItem>
                    {/* {this.state.row?.direction == 1 &&
                        <SimpleItem colSpan={30} label={{ text: 'بابت' }}>
                            <SelectBox rtlEnabled
                                items={[{ id: 0, summary: 'برداشت از سود' }, { id: 1, summary: 'پرداخت به راننده' }, { id: 1, summary: 'پرداخت بابت متریال' }]}
                                valueExpr='id' displayExpr='summary'
                                value={this.state.row.usageIx}
                                onValueChanged={e => { this.state.row.usageIx = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    } */
                    }

                    <SimpleItem colSpan={window.mView ? 60 : 30} />

                    {this.state.row?.direction == 1 &&
                        <SimpleItem colSpan={60} label={{ text: 'شرح' }}>
                            <TextArea
                                value={this.state.row.usagedescription}
                                onValueChanged={e => { this.state.row.usagedescription = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }

                    {/* <SimpleItem colSpan={30}>
                        <Uploader selectButtonText={'بارگذاری اسناد...'}
                            subPath={AuxFile.getTempPath('MoneyInOut', this.state.row?.id)}
                        />
                    </SimpleItem> */}

                    <SimpleItem colSpan={60}>
                        <PrepareAuxFile table='MoneyInOut' rowId={this.state.row?.id} />
                    </SimpleItem>

                </Form>
            </div>
        );
    }
}

export default MoneyInOut;
